import { apiRequest } from "../index";

export const getAllNotifications = ({page , limit}) => {
  return apiRequest(`/api/common/notifications?page=${page}&limit=${limit}`, "GET");
};

export const getUnreadNotificationCount = () => {
  return apiRequest(`/api/common/notifications/unread-count`, "GET");
};

export const markNotificationAsRead = (notificationId) => {
  return apiRequest(`/api/common/notifications/read/${notificationId}`, "PUT");
};

export const markAllNotificationsAsRead = () => {
  return apiRequest(`/api/common/notifications/read-all`, "PUT");
};

export const deleteNotifications = () => {
  return apiRequest(`/api/common/notifications`, "DELETE");
};
